import { useQuery } from 'react-query';
import { network } from 'services/network';
import { QueryKeys } from 'api/queryKeys';

export const queryFn = () => {
    return network.get('api/bo/project/getProgramGeneralHierarchyList').then((response) => {
        return response.data;
    });
};

export const useQueryGetProgramGeneralHierarchyList = (params) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['GetProgramGeneralHierarchyList', params],
        queryFn: () => queryFn(),
        cacheTime: 0,
    });
};

export interface QueryResponse {
    children: QueryResponse[];
    id: number;
    name: string;
    parentUUID: string | null;
    type: string;
    uuid: string;
}
